import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from 'react-router-dom';

interface NextLinkProps extends Omit<RouterLinkProps, 'to'> {
  href: string;
  children: React.ReactNode;
}

export function Link({ href, children, ...props }: NextLinkProps) {
  return (
    <RouterLink to={href} {...props}>
      {children}
    </RouterLink>
  );
}

export default Link;
